import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';
import Options from './Options';
import EmailGPT from './EmailGPT';
import SupportGPT from './SupportGPT';
import BotAvatar from './BotAvatar';
import HelpDrawer from './HelpDrawer';
import VideoPlayer from './VideoPlayer';
import CustomBotChatMessage from './CustomBotChatMessage';

const botName = 'davie.ai';

const config = {
    initialMessages: [
        createChatBotMessage(
            'What would you like help with? You can ask a general question or select an option below.',
            {
                widget: 'options',
            }
        ),
    ],
    botName: botName,
    state: {
        userInput: '',
    },
    widgets: [
        {
            widgetName: 'options',
            widgetFunc: (props) => <Options {...props} />,
        },
        {
            widgetName: 'emailGPT',
            widgetFunc: (props) => <EmailGPT {...props} />,
            mapStateToProps: ['userInput', 'widget'],
        },
        {
            widgetName: 'supportGPT',
            widgetFunc: (props) => <SupportGPT {...props} />,
            mapStateToProps: ['userInput'],
        },
        {
            widgetName: 'helpDrawer',
            widgetFunc: (props) => <HelpDrawer {...props} />,
            mapStateToProps: ['userInput'],
        },
        {
            widgetName: 'videoPlayer',
            widgetFunc: (props) => <VideoPlayer {...props} />,
            mapStateToProps: ['userInput'],
        },
    ],
    customComponents: {
        // Replaces the default header
        botChatMessage: (props) => <CustomBotChatMessage {...props} />,

        // Replaces the default bot avatar
        botAvatar: (props) => <BotAvatar {...props} />,
        header: () => (
            <div
                style={{
                    backgroundColor: '#2e69fe',
                    color: 'white',
                    padding: '10px',
                    borderRadius: '3px',
                }}
            >
                {"Chat with davie.ai's intelligent expert!"}
            </div>
        ),
    },

    customStyles: {
        botMessageBox: {
            backgroundColor: '#2e69fe',
        },
        chatButton: {
            backgroundColor: '#2e69fe',
        },
    },
};

export default config;
